import { PATHS } from '@/constants/paths';
import { OfferType } from '@/types';

const CATEGORY_CODE_TO_SLUG: Record<string, string> = {
  '0': 'grundstueck',
  '8': 'haus',
  '17': 'zinshaus',
  '23': 'gewerbe',
  '27': 'wohnung',
  '35': 'buero',
  '39': 'geschaeft',
  '47': 'sonderobjekt',
  '59': 'keller',
  '61': 'parken',
  '91': 'gastgewerbe',
  '95': 'beherbergung',
  '100': 'land-forstwirtschaft',
  '111': 'zimmer',
};

export const slugifyLocationName = (name: string): string =>
  name
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const buildDirectLinkSlug = (
  categoryCode: string,
  offerType: OfferType,
  locationName: string,
): string | null => {
  const categorySlug = CATEGORY_CODE_TO_SLUG[categoryCode];
  if (!categorySlug) return null;

  const offerSlug = offerType === OfferType.SELL ? 'kaufen' : 'mieten';
  const locationSlug = slugifyLocationName(locationName);
  if (!locationSlug) return null;

  return `${categorySlug}-${offerSlug}-in-${locationSlug}`;
};

export const buildDirectLinkHref = (slug: string) => `/${PATHS.DIRECTLINK}/${slug}`;
